import DialogType from './DialogType';

export default class UserDialogType extends DialogType {
  constructor({ message }) {
    super({
      typeDialog: 'user',
      message,
    });
  }
}
